import { render, staticRenderFns } from "./bindUser.vue?vue&type=template&id=f303fbc6&scoped=true&"
import script from "./bindUser.vue?vue&type=script&lang=js&"
export * from "./bindUser.vue?vue&type=script&lang=js&"
import style0 from "./bindUser.vue?vue&type=style&index=0&id=f303fbc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f303fbc6",
  null
  
)

export default component.exports